import styled, { keyframes, css } from 'styled-components'

const fadeIn = keyframes`
  from { opacity: 0; transform: translateY(8px); }
  to { opacity: 1; transform: translateY(0); }
`

const softPulse = keyframes`
  0%, 100% { box-shadow: 0 4px 24px rgba(113, 84, 176, 0.12); }
  50% { box-shadow: 0 8px 32px rgba(113, 84, 176, 0.18); }
`

export const EventListingPageWrap = styled.div`
  width: 100%;
  min-height: calc(100vh - 64px);
  background: linear-gradient(165deg, #faf9fc 0%, #f3f0f9 35%, #fdfcff 100%);
  display: flex;
  flex-direction: column;
  align-items: center;
  font-family: 'Outfit', -apple-system, BlinkMacSystemFont, sans-serif;
  padding: 24px 16px 48px;
  @media (min-width: 768px) {
    padding: 40px 24px 64px;
  }
`

export const EventListingContent = styled.div`
  width: 100%;
  max-width: 720px;
  animation: ${fadeIn} 0.4s ease-out;
`

export const EventListingHero = styled.div`
  display: flex;
  align-items: center;
  gap: 20px;
  padding: 28px 24px;
  margin-bottom: 32px;
  background: #ffffff;
  border-radius: 20px;
  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.06), 0 0 0 1px rgba(0, 0, 0, 0.04);
  border: 1px solid rgba(255, 255, 255, 0.8);
  @media (min-width: 660px) {
    padding: 32px 28px;
    gap: 24px;
  }
`

export const EventListingMentorAvatarWrap = styled.div`
  flex-shrink: 0;
  position: relative;
`

export const EventListingMentorAvatar = styled.img`
  width: 72px;
  height: 72px;
  border-radius: 50%;
  object-fit: cover;
  border: 3px solid rgba(113, 84, 176, 0.2);
  box-shadow: 0 4px 16px rgba(113, 84, 176, 0.15);
  @media (min-width: 660px) {
    width: 88px;
    height: 88px;
  }
`

export const EventListingMentorInfo = styled.div`
  flex: 1;
  min-width: 0;
`

export const EventListingMentorName = styled.h1`
  margin: 0 0 6px 0;
  font-size: 1.35rem;
  font-weight: 700;
  color: #1f1b24;
  letter-spacing: -0.02em;
  line-height: 1.3;
  @media (min-width: 660px) {
    font-size: 1.6rem;
  }
`

export const EventListingMentorBio = styled.p`
  margin: 0;
  font-size: 0.9rem;
  font-weight: 400;
  color: #5c5563;
  line-height: 1.5;
  @media (min-width: 660px) {
    font-size: 0.95rem;
  }
`

export const EventListingQuals = styled.div`
  margin-top: 12px;
  padding-top: 12px;
  border-top: 1px solid rgba(0, 0, 0, 0.06);
`

export const EventListingQualsLabel = styled.span`
  font-size: 0.75rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  color: #8b8398;
`

export const EventListingQualsText = styled.p`
  margin: 4px 0 0 0;
  font-size: 0.875rem;
  font-weight: 500;
  color: #3d3744;
  line-height: 1.45;
`

export const EventListingSection = styled.section`
  margin-top: 8px;
`

export const EventListingSectionTitle = styled.h2`
  margin: 0 0 6px 0;
  font-size: 1.25rem;
  font-weight: 700;
  color: #1f1b24;
  letter-spacing: -0.02em;
  @media (min-width: 768px) {
    font-size: 1.4rem;
  }
`

export const EventListingSectionSubtitle = styled.p`
  margin: 0 0 24px 0;
  font-size: 0.875rem;
  font-weight: 400;
  color: #6b6574;
  line-height: 1.45;
`

export const EventListingEventList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 14px;
`

export const EventListingEventContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: 20px 20px 20px 20px;
  border-radius: 16px;
  border: 1.5px solid ${(props) => (props.$selected ? 'rgba(113, 84, 176, 0.45)' : 'rgba(0, 0, 0, 0.08)')};
  cursor: ${(props) => (props.$selected ? 'default' : 'pointer')};
  background: ${(props) => (props.$selected ? 'rgba(255, 255, 255, 0.95)' : '#ffffff')};
  box-shadow: ${(props) =>
    props.$selected
      ? '0 8px 32px rgba(113, 84, 176, 0.14), 0 0 0 1px rgba(113, 84, 176, 0.08)'
      : '0 2px 12px rgba(0, 0, 0, 0.04)'};
  transition: border-color 0.2s ease, box-shadow 0.2s ease, background 0.2s ease, transform 0.15s ease;
  position: relative;
  overflow: hidden;
  animation: ${fadeIn} 0.35s ease-out;
  ${(props) => props.$selected && css`animation: ${softPulse} 2.5s ease-in-out infinite;`}

  &:hover {
    border-color: ${(props) => (props.$selected ? 'rgba(113, 84, 176, 0.45)' : 'rgba(113, 84, 176, 0.25)')};
    box-shadow: ${(props) =>
      props.$selected
        ? '0 8px 32px rgba(113, 84, 176, 0.14)'
        : '0 6px 24px rgba(0, 0, 0, 0.08)'};
    ${(props) => !props.$selected && 'transform: translateY(-1px);'}
  }
  @media (min-width: 768px) {
    padding: 24px 24px 24px 24px;
  }
`

export const EventListingEventHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 12px;
  margin-bottom: 8px;
`

export const EventListingEventTitle = styled.div`
  font-size: 1.05rem;
  font-weight: 700;
  color: #1f1b24;
  line-height: 1.35;
  flex: 1;
  min-width: 0;
  @media (min-width: 768px) {
    font-size: 1.15rem;
  }
`

export const EventListingSpecialTag = styled.div`
  background: linear-gradient(135deg, #e8e0f5 0%, #ddd2ef 100%);
  color: #5c3d8a;
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-size: 0.7rem;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  height: 26px;
  padding: 0 10px;
  border-radius: 999px;
  flex-shrink: 0;
  box-shadow: 0 1px 3px rgba(92, 61, 138, 0.15);
`

export const EventListingEventDescription = styled.p`
  margin: 0 0 14px 0;
  font-size: 0.875rem;
  font-weight: 400;
  color: #5c5563;
  line-height: 1.5;
`

export const EventListingExpandContent = styled.div`
  padding-top: 4px;
  border-top: 1px solid rgba(0, 0, 0, 0.06);
`

export const EventListingMetaRow = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  margin-bottom: 8px;
  font-size: 0.875rem;
  color: #4a4452;
  flex-wrap: wrap;
  &:last-of-type {
    margin-bottom: 0;
  }
`

export const EventListingMetaLabel = styled.span`
  font-weight: 600;
  color: #3d3744;
  min-width: 0;
`

export const EventListingMetaValue = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-weight: 400;
`

export const EventListingPriceRow = styled.div`
  margin-top: 12px;
  margin-bottom: 16px;
  display: flex;
  align-items: baseline;
  gap: 8px;
  flex-wrap: wrap;
`

export const EventListingPriceStrikethrough = styled.span`
  text-decoration: line-through;
  font-weight: 400;
  color: #8b8398;
  font-size: 0.9rem;
`

export const EventListingPriceFinal = styled.span`
  font-weight: 700;
  color: #2d2438;
  font-size: 1rem;
`

export const EventListingBookButton = styled.a`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  margin-top: 4px;
  padding: 12px 24px;
  font-size: 0.85rem;
  font-weight: 700;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  text-decoration: none;
  color: #ffffff;
  background: linear-gradient(135deg, #7154b0 0%, #5c3d8a 100%);
  border: none;
  border-radius: 12px;
  cursor: pointer;
  transition: transform 0.15s ease, box-shadow 0.2s ease, opacity 0.2s ease;
  box-shadow: 0 4px 14px rgba(113, 84, 176, 0.35);
  min-height: 44px;

  &:hover {
    transform: translateY(-1px);
    box-shadow: 0 6px 20px rgba(113, 84, 176, 0.4);
    color: #ffffff;
  }
  &:active {
    transform: translateY(0);
  }
`

/* Referred / by-invitation-only view when no public sessions */
export const EventListingReferredCard = styled.div`
  padding: 32px 24px;
  margin-top: 0;
  background: #ffffff;
  border-radius: 20px;
  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.06), 0 0 0 1px rgba(0, 0, 0, 0.04);
  text-align: center;
  border: 1px solid rgba(113, 84, 176, 0.12);
  @media (min-width: 768px) {
    padding: 40px 48px;
  }
`

export const EventListingReferredBadge = styled.div`
  display: inline-block;
  font-size: 0.7rem;
  font-weight: 700;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  color: #5c3d8a;
  background: linear-gradient(135deg, rgba(113, 84, 176, 0.12) 0%, rgba(92, 61, 138, 0.08) 100%);
  padding: 8px 14px;
  border-radius: 999px;
  margin-bottom: 20px;
`

export const EventListingReferredHeading = styled.h2`
  margin: 0 0 12px 0;
  font-size: 1.35rem;
  font-weight: 700;
  color: #1f1b24;
  letter-spacing: -0.02em;
  line-height: 1.35;
  @media (min-width: 768px) {
    font-size: 1.5rem;
  }
`

export const EventListingReferredText = styled.p`
  margin: 0 0 20px 0;
  font-size: 0.95rem;
  font-weight: 400;
  color: #5c5563;
  line-height: 1.6;
  max-width: 520px;
  margin-left: auto;
  margin-right: auto;
  @media (min-width: 768px) {
    font-size: 1rem;
    margin-bottom: 24px;
  }
`

export const EventListingReferredContact = styled.p`
  margin: 0;
  font-size: 0.875rem;
  font-weight: 500;
  color: #3d3744;
  line-height: 1.5;
`

export const EventListingReferredEmail = styled.a`
  color: #7154b0;
  font-weight: 600;
  text-decoration: none;
  &:hover {
    text-decoration: underline;
  }
`
